import { View } from 'dripsy';
import React, { useContext, useEffect } from 'react';

import { useSubscriptionDetails } from './useSubscriptionDetails.hook';
import { LayoutContext } from 'contexts/LayoutContext';
import { SubscriptionBody } from './SubscriptionBody';
import { FormSkeleton } from '../../components/FormSkeleton';
import { SubscriptionDetailsStackRoutes, SubscriptionDetailsStackScreenProps } from './type';
import { UniTabHeader } from '@/design-system/components/tabs';
import { ModalHeader } from '@/design-system/components/modal';

export const SubscriptionDetails: React.FC<SubscriptionDetailsStackScreenProps<SubscriptionDetailsStackRoutes.Main>> = ({
  route,
  navigation
}) => {
  const { subscription: prevSubscription, onUpdate, onLayout } = route.params;

  const {
    isLoading,
    subscriptionDetails: subscription,
    subscriptionBodyProps,
    query
  } = useSubscriptionDetails({ id: prevSubscription.id, onUpdate });

  const layout = useContext(LayoutContext);

  // Remove query on unmount
  useEffect(() => {
    return () => {
      query.remove();
    };
  }, []);

  return (
    <View
      sx={{
        height: layout.isMobile ? '100%' : 'auto',
        width: layout.dimensions.width,
        maxWidth: layout.isMobile ? layout.dimensions.width : Math.min(500, layout.dimensions.width),
        backgroundColor: '$backgroundPrimary'
      }}
      onLayout={(event) => {
        const { width, height } = event.nativeEvent.layout;
        onLayout(event);
      }}>
      <Header title={subscription?.offerName || ''} isMobile={layout.isMobile} onClose={() => navigation.popToTop()} />
      {isLoading && <FormSkeleton />}
      {subscription && (
        <SubscriptionBody
          {...subscriptionBodyProps}
          onLayout={(event) => {
            onLayout(event);
          }}
          onUpdate={onUpdate}
          sx={{ justifyContent: 'space-between', padding: layout.isMobile ? '$4' : '$7' }}
        />
      )}
    </View>
  );
};

const Header = ({ title, isMobile, onClose }: { title: string; isMobile: boolean; onClose: () => void }) => {
  if (isMobile) {
    return <UniTabHeader title={title} onBack={onClose} />;
  }

  return <ModalHeader title={title} closeModal={onClose} />;
};
